export enum OtherInputParameterType {
    Dynamic = 'dynamic',
    Same = 'same',
    Dataset = 'dataset',
    Result = 'result',
    Schema = 'schema',
    ParquetStatus = 'parquet-status',
}
